import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {CssBaseline} from '@material-ui/core'

ReactDOM.render(
  <div> 
    <CssBaseline/>
    <App />
  </div>,
document.getElementById('root')
);